import PitchType from "../../enums/PitchType.js";

// FOR MAX - Note that it does not have to be tagged, as the fastest pitch thrown by a pitcher will be a fastball, even if it is tagged incorrectly.  ???????? AK - I strongly disagree with this idea, it will contain a mess in data. Just imagine that we have a relief pitcher who did not throw any fastball, we can't assume that untagged pitch is actually a fastball. Also I don't think that we should use different data set for calculating avg and max values. It can lead to the situation that we have max but we don't have an avg...
// Four Seam, Two Seam, Sinker, Cutter, Fastball, see https://docs.google.com/document/d/1DjxZU1qm8P7BjTRsQSmNxzEbSBT2Oo0nshhw561PAdc/edit#heading=h.gzur83k5ek7y
const fastballs = [
    PitchType.FourSeamFastball.key, PitchType.TwoSeamFastball.key,
    PitchType.Sinker.key, PitchType.Cutter.key,
    // fallback for BBH
    PitchType.Fastball.key,
    // Softball types, @see https://flightscope.atlassian.net/browse/BBP-891
    PitchType.DropBall.key,
    PitchType.RiseBall.key,
];

const fastballClassifier = function(taggedPitchType) {
    if (typeof taggedPitchType !== 'string'){
        return false;
    }

    return fastballs.includes(taggedPitchType);
}

export default fastballClassifier;